import { render, staticRenderFns } from "./tableView.vue?vue&type=template&id=591df2ca&scoped=true"
import script from "./tableView.vue?vue&type=script&lang=js"
export * from "./tableView.vue?vue&type=script&lang=js"
import style0 from "./tableView.vue?vue&type=style&index=0&id=591df2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591df2ca",
  null
  
)

export default component.exports